import axios from "axios";
import store from "../redux/store";
import { getClientID, getURL } from "../redux/selectors";

const getReportData = async ({ reqID, pagenum }) => {
  const state = store.getState();
  const url = getURL(state);
  const clientID = getClientID(state);

  return await axios
    .post(`${process.env.REACT_APP_BACKEND_DOMAIN}/d1services`, {
      url,
      data: {
        service: "getReportData",
        clientID,
        reqID,
        pagenum,
        appID: process.env.REACT_APP_SOFTONE_APPID,
      },
    })
    .then((res) => res.data)
    .catch((er) => ({ success: false, error: er.message }));
};

export default getReportData;
